import { Card } from "@/components/ui/card";

const APP_VERSION = "1.0.0";
const LAST_UPDATED = new Date().toISOString().split('T')[0]; // Build date

export function VersionInfo() {
  return (
    <Card className="mt-8 p-4 bg-muted/50">
      <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-muted-foreground">
        <div>
          <span className="font-semibold">App Version:</span> {APP_VERSION}
        </div>
        <div>
          <span className="font-semibold">Last Updated:</span> {LAST_UPDATED}
        </div>
        <div>
          <span className="font-semibold">Build Time:</span> {new Date().toLocaleString()}
        </div>
      </div>
    </Card>
  );
}
